import { ReportingItem } from "vmd-types";

import { TestAppState } from "../../app";
import {
  CRITICAL_CRITICALITY_LEVELS,
  DONUT_CHART_COLORS,
} from "../../constants";

/**
 * Shared by the dashboard cards under `../../pages/dashboard/cards` (#2222):
 * pulled out of `dashboard-plugin.tsx` verbatim, unchanged, because more than
 * one card file needs them. Anything only one card used stayed in that card's
 * own file instead of moving here.
 */

export type DashboardChartEntry = {
  label: string;
  count: number;
  color: string;
};

export const criticalityLevelSet = new Set<string>(CRITICAL_CRITICALITY_LEVELS);

export const getAllReportingItems = (
  dashboard: TestAppState["dashboard"] | undefined
): ReportingItem[] => {
  return (dashboard?.projects ?? [])
    .flatMap((project) => project.reportingItems ?? [])
    .filter((item) => !item?.isChannelHeader);
};

export const getArrayFieldData = (
  items: ReportingItem[],
  picker: (item: ReportingItem) => string[] | undefined
): { entries: DashboardChartEntry[] } => {
  const counts = new Map<string, number>();

  for (const item of items) {
    for (const value of picker(item) ?? []) {
      if (!value) {
        continue;
      }
      counts.set(value, (counts.get(value) ?? 0) + 1);
    }
  }

  const entries = Array.from(counts.entries())
    .sort((a, b) => b[1] - a[1])
    .map(([label, count], index) => ({
      label,
      count,
      color: DONUT_CHART_COLORS[index % DONUT_CHART_COLORS.length],
    }));

  return { entries };
};

export const withTotalInTitle = (title: string, total: number) =>
  `${title} (${total})`;
